
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos/consorcio",
      function () {
        return require("private-next-pages/servicos/consorcio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicos/consorcio"])
      });
    }
  